import * as React from 'react';
import { Flex } from '../../Flex';
import { Box } from '../../Box';
var ObjectFieldTemplate = function (props) {
    var _a, _b, _c;
    var TitleField = props.TitleField, DescriptionField = props.DescriptionField;
    var responsive = !!((_a = props.uiSchema['ui:options']) === null || _a === void 0 ? void 0 : _a.responsive);
    var flex = ((_c = (_b = props.uiSchema['ui:options']) === null || _b === void 0 ? void 0 : _b.flex) !== null && _c !== void 0 ? _c : []);
    return (React.createElement("section", null,
        props.schema.title && (props.uiSchema['ui:title'] || props.title) && (React.createElement(TitleField, { id: props.idSchema.$id + "__title", title: props.title || props.uiSchema['ui:title'], required: props.required })),
        props.description && (React.createElement(DescriptionField, { id: props.idSchema.$id + "__description", description: props.description })),
        React.createElement(Flex, { flexDirection: responsive ? 'row' : 'column', flexWrap: responsive ? 'wrap' : 'nowrap' }, props.properties.map(function (prop, index) { return (React.createElement(Box, { key: index, mr: 2, flex: flex[index] || 1 }, prop.content)); }))));
};
export default ObjectFieldTemplate;
